export const headCells = [
  {
    id: "text",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Delivery Format",
    width: 200,
  },
  {
    id: "Category",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Category",
    width: 150,
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Type",
    width: 150,
  },
  {
    id: "Status",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Status",
    width: 100,
  },
  {
    id: "Actions",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "Actions",
    width: 150,
  },
];
